<template>
  <div>
    <h1>{{ title }}</h1>
    <p style="clear: both;">
      <Button
        v-if="validDownload"
        class="queryResultButtons"
        @click="download"
      >
        Download
      </Button>
      <Button
        class="queryResultButtons"
        @click="openResultsModal"
      >
        Previous Results
      </Button>
    </p>
    <div style="clear: both;">
      <QueryTable
        v-if="dataList.length"
        :query="'test'"
        :results="dataList"
        :context="'scheduled_query_result'"
        :show-action="true"
        :has-query-run="true"
        :full-data-present="true"
        style="background-color: white; border-left: unset"
      />
    </div>
    <Modal
      v-model="showResultsModal"
      :footer-hide="true"
      width="1100"
      scrollable
    >
      <h1>{{ modalTitle }}</h1>
      <Table
        :columns="modalColumns"
        :data="modalData"
        size="small"
        height="600"
        highlight-row
        @on-current-change="handleRowSelection"
      />
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import abtos from 'arraybuffer-to-string'
import papa from 'papaparse'
import QueryTable from './helper-components/QueryTable'
import _ from 'lodash'

export default {

  components: {
    QueryTable
  },
  data () {
    return {
      validDownload: true,
      signedUrl: '',
      columns: [],
      loading: false,
      dataList: [],
      history: [],
      hasData: false,
      title: '',
      showResultsModal: false,
      scheduledQueryId: 0,
      runs: [],
      modalTitle: '',
      modalColumns: [
        {
          title: 'Rows',
          key: 'rows',
          width: 80
        },
        {
          title: 'Size (kb)',
          key: 'kb',
          width: 90
        },
        {
          title: 'Started at',
          key: 'start'
        },
        {
          title: 'Finished at',
          key: 'end'
        },
        {
          title: 'Error',
          key: 'error',
          ellipsis: true,
          tooltip: true
        },
        {
          title: 'Download',
          key: 'download',
          width: 100,
          render: (h, params) => {
            if (params.row.success) {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'ios-download',
                    size: '24'
                  },
                  on: {
                    click: () => {
                      this.downloadRow(params.row.file)
                    }
                  }
                })
              ])
            }
          }
        }
      ],
      modalData: []
    }
  },

  watch: {
    $route () {
      this.getS3Object()
    }
  },

  mounted () {
    this.getS3Object()
  },

  methods: {
    async getS3Object () {
      try {
        this.validDownload = true
        this.showResultsModal = false
        const data = []
        this.dataList = []
        const fileName = this.$route.params.id
        this.scheduledQueryId = this.$route.params.id.split('-')[0]

        const scheduledQueryDetails = await axios.get(process.env.VUE_APP_API_URI + '/scheduled-queries/' + this.scheduledQueryId)

        if (!scheduledQueryDetails.data) {
          this.$Message.error('Query results expired')
          this.validDownload = false
          return
        }

        let recurrence = 'Hourly'
        const scheduleElements = scheduledQueryDetails.data.schedule.split(' ')

        if (scheduleElements[1] !== '*') {
          recurrence = 'Daily'
        }
        if (scheduleElements[4] !== '*') {
          recurrence = 'Weekly'
        }

        const response = await axios.get(`${process.env.VUE_APP_API_URI}/scheduled-queries/results/${fileName}?timestamp=${new Date().getTime()}`)
        this.signedUrl = response.data

        const content = await axios({
          url: this.signedUrl,
          responseType: 'arraybuffer',
          method: 'get'
        })

        this.title = `${scheduledQueryDetails.data.query_name.split('/').slice(-1)} - ${recurrence} at ${new Date(_.get(content, 'headers.last-modified'))}`
        this.modalTitle = `${scheduledQueryDetails.data.query_name.split('/').slice(-1)} - ${recurrence}`

        const uint8array = new Uint8Array(content.data)
        const results = abtos(uint8array, 'utf8')
        const parsed = papa.parse(results).data
        this.columns = parsed[0].map((column) => {
          return {
            title: column,
            key: column,
            width: 100,
            align: 'center',
            fixed: 'left'
          }
        })

        parsed.slice(1, -1).forEach((row, rowIndex) => {
          data[rowIndex] = {}
          row.forEach((item, columnIndex) => {
            data[rowIndex][this.columns[columnIndex].title] = item
          })
        })

        this.dataList = data
      } catch (error) {
        this.$Message.error(`Failed to fetch scheduled query results: ${error}`)
      }
    },

    async download () {
      try {
        const response = await axios.get(process.env.VUE_APP_API_URI + '/scheduled-queries/results/' + this.$route.params.id)
        this.signedUrl = response.data
        window.open(this.signedUrl)
      } catch (error) {
        this.$Message.error(`Failed to download scheduled query results: ${error}`)
      }
    },

    async downloadRow (file) {
      try {
        const response = await axios.get(process.env.VUE_APP_API_URI + '/scheduled-queries/results/' + file)
        this.signedUrl = response.data
        window.open(this.signedUrl)
      } catch (error) {
        this.$Message.error(`Failed to download scheduled query results: ${error}`)
      }
    },

    openResultsModal () {
      this.showResultsModal = true
      this.getQueryResults()
    },

    async getQueryResults () {
      const response = await axios.get(`${process.env.VUE_APP_API_URI}/scheduled-queries/${this.scheduledQueryId}/history`)
      const data = response.data.sort((a, b) => { return new Date(b.started_at) - new Date(a.started_at) }).map(run => {
        return {
          success: run.success,
          rows: run.number_rows,
          kb: Math.ceil(run.bytes / 1000),
          start: new Date(new Date(run.started_at).setUTCHours(new Date(run.started_at).getHours())).toString().split(' GMT')[0],
          end: new Date(new Date(run.finished_at).setUTCHours(new Date(run.finished_at).getHours())).toString().split(' GMT')[0],
          error: run.error_message && JSON.parse(run.error_message).message,
          file: run.file
        }
      })
      this.modalData = data
    },

    handleRowSelection (currentRow) {
      this.$router.push('/scheduled-query/' + currentRow.file)
    }
  }
}
</script>

<style>
  .ivu-table-row td {
    cursor: pointer;
  }

  .white-background {
    background-color: var(--color-white);
  }

  .query-results-container {
    padding-top: 8px;
    position: relative;
    border-left: 1px solid var(--color-gray-border);
    background-color: var(--color-body-background);
  }

  .query-table-container {
    position: relative;
  }

  .query-table {
    transition: all 0.3s ease;
  }

  .toolbar-container {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 12px;
    background-color: var(--color-body-background);
  }

  .white-background .toolbar-container {
    background-color: var(--color-white);
  }

  .page-tabs {
    padding-left: 8px;
  }

  .page-nav {
    display: flex;
    align-items: baseline;
    padding-right: 8px;
    line-height: 32px;
  }

  .ruler {
    position: absolute;
    visibility: hidden;
    white-space: nowrap;
  }

  .table-buttons-container {
    padding-left: 8px;
  }

  .table-buttons-container i {
    max-width: 16px;
    min-width: 16px;
    height: 16px;
    margin-right: 8px;
    padding: 0;
    width: 16px;
    display: inline-block;
    font-size: 14px;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
    text-rendering: auto;
    text-align: center;
    line-height: 1;
    vertical-align: middle;
    color: var(--color-black);
  }

  .query-chart-result {
    width: 100%;
    min-height: 400px;
    background-color: var(--color-white);
  }

  .query-sider {
    background: var(--color-white);
    max-height: 530px;
    overflow-y: auto;
    border: 1px solid var(--color-gray-border);
    border-left: none;
  }

  .query-sider.ivu-layout-sider-collapsed {
    border-right: none;
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }

  .sticky-content {
    padding: 16px;
    background-color: var(--color-body-background);
  }

  .modal >>> .ivu-modal-close .ivu-icon {
    font-weight: 700;
  }

  .t-header {
    font-size: 12px;
  }

  .t-container {
    font-size: 12px;
  }

  .header-line {
    font-weight: bold;
    height: 40px !important;
  }

  .item-cell-inner span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .sort {
    line-height: 20px;
    border-bottom: 1px solid var(--color-gray-border);
    font-weight: bold;
    font-size: 14px;
    padding: 0 8px;
    margin-bottom: 5px;
  }

  .ivu-modal-fullscreen-no-footer .ivu-modal-body {
    background-color: var(--color-body-background);
  }

  .queryResultButtons {
    float: right;
    margin-bottom: 20px;
  }
</style>
